// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Close Account flow — scoped .ca-* */

.ca-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 24px 56px;
  max-width: 1200px;
  margin: 0 auto;
}

.ca-page *,
.ca-page *::before,
.ca-page *::after {
  box-sizing: border-box;
}

.ca-page__crumbs {
  margin-bottom: 18px;
}

.ca-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.ca-page__crumbItem--active {
  color: #e8e8e8;
}

body.light_theme .ca-page__crumbItem--active {
  color: #101828;
}

.ca-page__crumbSep {
  color: #8e939c;
}

.ca-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.ca-page__title {
  margin: 0 0 28px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #e4e4e4;
}

body.light_theme .ca-page__title {
  color: #101828;
}

.ca-prefetchHint {
  margin: -12px 0 20px;
  font-size: 14px;
  color: #667085;
}

.ca-errorBanner {
  padding: 12px 14px;
  border-radius: 10px;
  background: #fef3f2;
  border: 1px solid #fecdca;
  color: #b42318;
  font-size: 14px;
}

.ca-errorBanner--page {
  margin: -12px 0 20px;
}

.ca-errorBanner__text {
  margin: 0 0 10px;
}

.ca-btnGhost {
  min-height: 40px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid #d0d5dd;
  background: #fff;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.ca-btnGhost:hover:not(:disabled) {
  background: #f9fafb;
}

.ca-btnGhost--inline {
  border-radius: 8px;
  min-height: 36px;
  padding: 0 14px;
}

/* Step 1 — Personal Data Retention (centered) */
.ca-retention {
  max-width: 600px;
  margin: 65px auto 30px;
  text-align: left;
}

.ca-retention__sub {
  margin: 0 0 16px;
  font-size: 30px;
  font-weight: 600;
  color: #e8e8e8;
}

body.light_theme .ca-retention__sub {
  color: #101828;
}

.ca-retention__text {
  margin: 0 0 28px;
  font-size: 18px;
  line-height: 1.65;
  font-weight: 400;
  color: #cfcfcf;
  text-align: left;
}

body.light_theme .ca-retention__text {
  color: #4b5563;
}

.ca-btn-primary {
  display: block;
  width: 100%;
  max-width: 100%;
  height: 50px;
  border: none;
  border-radius: 999px;
  background: #2d2e32;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

section.ca-assets {
  max-width: 620px;
  margin: 62px auto;
}

.ca-btn-primary:hover {
  opacity: 0.8;
}


.ca-btn-primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Step 2 — Reason */
.ca-reason {
  margin-top: 8px;
}

.ca-reason__heading {
  margin: 0 0 18px;
  font-size: 27px;
  font-weight: 500;
  color: #f3f3f3;
}

body.light_theme .ca-reason__heading {
  color: #101828;
}

.ca-reason__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 28px;
}

.ca-reason__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 29px 30px;
  border: none;
  color: #fff;
  border-radius: 10px;
  background: #f5f6f708;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
}

body.light_theme .ca-reason__option {
  background: #f5f6f7;
  color: #111111;
}

.ca-reason__option.is-selected {
  outline: none;
  background: #d1aa67;
}

body.light_theme .ca-reason__option.is-selected {
  background: #F5F6F7;
}

.ca-reason__radio {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ca-reason__radio::after {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: transparent;
}

.ca-reason__option.is-selected .ca-reason__radio {
  border-color: #101828;
}

.ca-reason__option.is-selected .ca-reason__radio::after {
  background: #101828;
}

/* Step 3 — Assets */
.ca-assets {
  margin-top: 8px;
}

.ca-assets__lead {
  margin: 0 0 16px;
  font-size: 28px;
  font-weight: 600;
  color: #f1f1f1;
}

body.light_theme .ca-assets__lead {
  color: #101828;
}

.ca-assets__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 28px;
}

.ca-assets__row {
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: row-reverse;
  gap: 12px;
  padding: 29px 24px;
  border-radius: 8px;
  background: #f5f6f712;
  font-size: 16px;
  font-weight: 500;
  color: #e5e5e5;
}

body.light_theme .ca-assets__row {
  background: #F5F6F7;
  color: #101828;
}

.ca-assets__radioArt {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #9ca3af;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.ca-assets__radioArt::after {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #101828;
}

.ca-assets__waiver {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 28px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.55;
  color: #c5c5c5;
}

body.light_theme .ca-assets__waiver {
  color: #374151;
}

.ca-assets__waiver input {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: #101828;
}

/* Confirmation modal */
.ca-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 100000022;
}


body.light_theme .ca-modal-overlay {
  background-color: rgb(255 255 255 / 20%);
}

.ca-modal {
  width: 560px;
  max-width: 92vw;
  border-radius: 18px;
  background: #1e202670;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid #2b31397a;
  box-shadow: 0 28px 64px rgba(0, 0, 0, 0.5);
  padding: 26px 24px 22px;
  position: relative;
}

body.light_theme .ca-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #eef2f68a;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.20);
}

.ca-modal__close {
  position: absolute;
  top: 14px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #eaecef;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
}

body.light_theme .ca-modal__close {
  color: #111827;
}

.ca-modal__close:hover {
  background: rgba(255, 255, 255, 0.1);
}

body.light_theme .ca-modal__close:hover {
  background: rgba(17, 24, 39, 0.06);
}

.ca-modal__title {
  margin: 17px 0 10px;
  padding: 0 36px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: #eaecef;
  line-height: 1.35;
}

body.light_theme .ca-modal__title {
  color: #101828;
}

.ca-modal__subtitle {
  margin: 0 0 18px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: #84888C;
}

body.light_theme .ca-modal__subtitle {
  color: #6A7282;
}

.ca-modal__box {
  border: 1px solid #2b3139;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 22px;
  background: none;
}

body.light_theme .ca-modal__box {
  border: 1px solid #E4E4E4;
}

.ca-modal__check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 12px;
  line-height: 1.5;
  color: #eaecef;
  cursor: pointer;
}

body.light_theme .ca-modal__check {
  color: #111827;
}

.ca-modal__check:last-child {
  margin-bottom: 4px;
}

.ca-modal__check input {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: #101828;
}

.ca-modal__confirm {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 50px;
  background: #2b3139;
  color: #eaecef;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

body.light_theme .ca-modal__confirm {
  background: #2b2b2b;
  color: #fff;
}

.ca-modal__confirm:hover:not(:disabled) {
  background: #1a1a1a;
}

.ca-modal__confirm:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Email verification modal (same pattern as security disable flow) */
.ca-evm-overlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 100000023;
}

.ca-evm {
  width: 539px;
  max-width: 92vw;
  border-radius: 16px;
  background: rgb(255 255 255 / 20%);
  border: 1px solid #eef2f6;
  box-shadow: 0 28px 64px rgba(15, 23, 42, 0.22);
  padding: 24px 24px 20px;
  position: relative;
}

.ca-evm__close {
  position: absolute;
  top: 14px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #111827;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
}

.ca-evm__close:hover {
  background: rgba(17, 24, 39, 0.06);
}

.ca-evm__title {
  margin: 0 0 12px;
  padding-right: 40px;
  font-size: 24px;
  font-weight: 600;
  color: #101828;
}

.ca-evm__desc {
  margin: 0 0 18px;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
  color: #6A7282;
}

.ca-evm__label {
  display: block;
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 500;
  color: #101828;
}

.ca-evm__inputWrap {
  position: relative;
  margin-bottom: 20px;
}

.ca-evm__input {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 0 100px 0 14px;
  font-size: 15px;
  font-weight: 500;
  color: #101828;
  background: #fff;
  outline: none;
}

/* .ca-evm__input:focus {
  border-color: #c99400;
  box-shadow: 0 0 0 3px rgba(201, 148, 0, 0.15);
} */

.ca-evm__getCode {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 6px 4px;
  font-size: 14px;
  font-weight: 600;
  color: #AC8A50;
  cursor: pointer;
}

.ca-evm__getCode:hover {
  color: #a67d00;
}

.ca-evm__submit {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #2b2b2b;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 16px;
}

.ca-evm__submit:hover:not(:disabled) {
  background: #1a1a1a;
}

.ca-evm__submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.ca-evm__help {
  display: block;
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  margin: 5px 0 20px;
  letter-spacing: -0.45px;
  font-size: 16px;
  font-weight: 600;
  color: #AC8A50;
  cursor: pointer;
  text-align: center;
}

.ca-evm__help:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.ca-evm__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
  font-size: 14px;
  font-weight: 500;
  color: #939495;
}

.ca-evm__footer img {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
  flex-shrink: 0;
}


@media (max-width: 991px) {

  .ca-page__title {
    margin: 0 0 15px;
    font-size: 24px;
  }

  .ca-retention__sub {
    margin: 0 0 12px;
    font-size: 22px;
  }

  .ca-retention__text {
    margin: 0 0 20px;
    font-size: 15px;
  }

}



@media (max-width: 767px) {

  .ca-page__title {
    margin: 0 0 15px;
    font-size: 20px;
  }

  .ca-reason__heading {
    font-size: 20px;
  }

  .ca-reason__option {
    padding: 18px;
    font-size: 14px;
  }

  .ca-retention__sub {
    margin: 0 0 12px;
    font-size: 17px;
  }

  .ca-assets__lead {
    font-size: 20px;
  }

  body .button23 {
    padding: 8px 24px;
    margin-top: 10px;
  }

  .ca-assets__row {
    font-size: 14px;
    padding: 18px;
  }

  section.ca-assets {
    margin: 30px auto;
  }

  .ca-modal-overlay {
    align-items: end;
    padding: 0px;
  }

  .ca-modal {
    width: 100%;
    max-width: 100%;
    border-radius: 18px 18px 0px 0px;
  }

  .ca-evm__title {
    font-size: 20px;
  }

  .ca-evm__desc {
    font-size: 14px;
  }

  .ca-modal__title {
    padding: 0 10px;
    font-size: 20px;
  }

  .ca-evm__submit {
    height: 42px;
  }

  .ca-evm-overlay {
    align-items: end;
    padding: 0px;
  }

  .ca-evm {
    width: 100%;
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .ca-retention__text {
    margin: 0 0 20px;
    font-size: 14px;
  }

  .ca-btn-primary {
    height: 42px;
    font-size: 14px;
  }

  .ca-retention {
    margin: 20px auto 10px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/closeAccount.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;;AAGA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,eAAe;EACf,QAAQ;EACR,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;EAC9C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;;EAEE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;AAEF;;;;AAIA;;EAEE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;AAEF","sourcesContent":["/* Close Account flow — scoped .ca-* */\n\n.ca-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 24px 56px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.ca-page *,\n.ca-page *::before,\n.ca-page *::after {\n  box-sizing: border-box;\n}\n\n.ca-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.ca-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.ca-page__crumbItem--active {\n  color: #e8e8e8;\n}\n\nbody.light_theme .ca-page__crumbItem--active {\n  color: #101828;\n}\n\n.ca-page__crumbSep {\n  color: #8e939c;\n}\n\n.ca-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.ca-page__title {\n  margin: 0 0 28px;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #e4e4e4;\n}\n\nbody.light_theme .ca-page__title {\n  color: #101828;\n}\n\n.ca-prefetchHint {\n  margin: -12px 0 20px;\n  font-size: 14px;\n  color: #667085;\n}\n\n.ca-errorBanner {\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fef3f2;\n  border: 1px solid #fecdca;\n  color: #b42318;\n  font-size: 14px;\n}\n\n.ca-errorBanner--page {\n  margin: -12px 0 20px;\n}\n\n.ca-errorBanner__text {\n  margin: 0 0 10px;\n}\n\n.ca-btnGhost {\n  min-height: 40px;\n  padding: 0 18px;\n  border-radius: 999px;\n  border: 1px solid #d0d5dd;\n  background: #fff;\n  color: #344054;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ca-btnGhost:hover:not(:disabled) {\n  background: #f9fafb;\n}\n\n.ca-btnGhost--inline {\n  border-radius: 8px;\n  min-height: 36px;\n  padding: 0 14px;\n}\n\n/* Step 1 — Personal Data Retention (centered) */\n.ca-retention {\n  max-width: 600px;\n  margin: 65px auto 30px;\n  text-align: left;\n}\n\n.ca-retention__sub {\n  margin: 0 0 16px;\n  font-size: 30px;\n  font-weight: 600;\n  color: #e8e8e8;\n}\n\nbody.light_theme .ca-retention__sub {\n  color: #101828;\n}\n\n.ca-retention__text {\n  margin: 0 0 28px;\n  font-size: 18px;\n  line-height: 1.65;\n  font-weight: 400;\n  color: #cfcfcf;\n  text-align: left;\n}\n\nbody.light_theme .ca-retention__text {\n  color: #4b5563;\n}\n\n.ca-btn-primary {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  height: 50px;\n  border: none;\n  border-radius: 999px;\n  background: #2d2e32;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\nsection.ca-assets {\n  max-width: 620px;\n  margin: 62px auto;\n}\n\n.ca-btn-primary:hover {\n  opacity: 0.8;\n}\n\n\n.ca-btn-primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Step 2 — Reason */\n.ca-reason {\n  margin-top: 8px;\n}\n\n.ca-reason__heading {\n  margin: 0 0 18px;\n  font-size: 27px;\n  font-weight: 500;\n  color: #f3f3f3;\n}\n\nbody.light_theme .ca-reason__heading {\n  color: #101828;\n}\n\n.ca-reason__list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.ca-reason__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  padding: 29px 30px;\n  border: none;\n  color: #fff;\n  border-radius: 10px;\n  background: #f5f6f708;\n  cursor: pointer;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 500;\n}\n\nbody.light_theme .ca-reason__option {\n  background: #f5f6f7;\n  color: #111111;\n}\n\n.ca-reason__option.is-selected {\n  outline: none;\n  background: #d1aa67;\n}\n\nbody.light_theme .ca-reason__option.is-selected {\n  background: #F5F6F7;\n}\n\n.ca-reason__radio {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 1px solid #d1d5db;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ca-reason__radio::after {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: transparent;\n}\n\n.ca-reason__option.is-selected .ca-reason__radio {\n  border-color: #101828;\n}\n\n.ca-reason__option.is-selected .ca-reason__radio::after {\n  background: #101828;\n}\n\n/* Step 3 — Assets */\n.ca-assets {\n  margin-top: 8px;\n}\n\n.ca-assets__lead {\n  margin: 0 0 16px;\n  font-size: 28px;\n  font-weight: 600;\n  color: #f1f1f1;\n}\n\nbody.light_theme .ca-assets__lead {\n  color: #101828;\n}\n\n.ca-assets__list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.ca-assets__row {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  flex-direction: row-reverse;\n  gap: 12px;\n  padding: 29px 24px;\n  border-radius: 8px;\n  background: #f5f6f712;\n  font-size: 16px;\n  font-weight: 500;\n  color: #e5e5e5;\n}\n\nbody.light_theme .ca-assets__row {\n  background: #F5F6F7;\n  color: #101828;\n}\n\n.ca-assets__radioArt {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid #9ca3af;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\n.ca-assets__radioArt::after {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #101828;\n}\n\n.ca-assets__waiver {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 28px;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #c5c5c5;\n}\n\nbody.light_theme .ca-assets__waiver {\n  color: #374151;\n}\n\n.ca-assets__waiver input {\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n  flex-shrink: 0;\n  accent-color: #101828;\n}\n\n/* Confirmation modal */\n.ca-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 100000022;\n}\n\n\nbody.light_theme .ca-modal-overlay {\n  background-color: rgb(255 255 255 / 20%);\n}\n\n.ca-modal {\n  width: 560px;\n  max-width: 92vw;\n  border-radius: 18px;\n  background: #1e202670;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid #2b31397a;\n  box-shadow: 0 28px 64px rgba(0, 0, 0, 0.5);\n  padding: 26px 24px 22px;\n  position: relative;\n}\n\nbody.light_theme .ca-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #eef2f68a;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.20);\n}\n\n.ca-modal__close {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #eaecef;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n}\n\nbody.light_theme .ca-modal__close {\n  color: #111827;\n}\n\n.ca-modal__close:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .ca-modal__close:hover {\n  background: rgba(17, 24, 39, 0.06);\n}\n\n.ca-modal__title {\n  margin: 17px 0 10px;\n  padding: 0 36px;\n  font-size: 24px;\n  font-weight: 600;\n  text-align: center;\n  color: #eaecef;\n  line-height: 1.35;\n}\n\nbody.light_theme .ca-modal__title {\n  color: #101828;\n}\n\n.ca-modal__subtitle {\n  margin: 0 0 18px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: center;\n  color: #84888C;\n}\n\nbody.light_theme .ca-modal__subtitle {\n  color: #6A7282;\n}\n\n.ca-modal__box {\n  border: 1px solid #2b3139;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 22px;\n  background: none;\n}\n\nbody.light_theme .ca-modal__box {\n  border: 1px solid #E4E4E4;\n}\n\n.ca-modal__check {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #eaecef;\n  cursor: pointer;\n}\n\nbody.light_theme .ca-modal__check {\n  color: #111827;\n}\n\n.ca-modal__check:last-child {\n  margin-bottom: 4px;\n}\n\n.ca-modal__check input {\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n  flex-shrink: 0;\n  accent-color: #101828;\n}\n\n.ca-modal__confirm {\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 50px;\n  background: #2b3139;\n  color: #eaecef;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\nbody.light_theme .ca-modal__confirm {\n  background: #2b2b2b;\n  color: #fff;\n}\n\n.ca-modal__confirm:hover:not(:disabled) {\n  background: #1a1a1a;\n}\n\n.ca-modal__confirm:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Email verification modal (same pattern as security disable flow) */\n.ca-evm-overlay {\n  position: fixed;\n  inset: 0;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 100000023;\n}\n\n.ca-evm {\n  width: 539px;\n  max-width: 92vw;\n  border-radius: 16px;\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #eef2f6;\n  box-shadow: 0 28px 64px rgba(15, 23, 42, 0.22);\n  padding: 24px 24px 20px;\n  position: relative;\n}\n\n.ca-evm__close {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #111827;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n}\n\n.ca-evm__close:hover {\n  background: rgba(17, 24, 39, 0.06);\n}\n\n.ca-evm__title {\n  margin: 0 0 12px;\n  padding-right: 40px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #101828;\n}\n\n.ca-evm__desc {\n  margin: 0 0 18px;\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #6A7282;\n}\n\n.ca-evm__label {\n  display: block;\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #101828;\n}\n\n.ca-evm__inputWrap {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.ca-evm__input {\n  width: 100%;\n  height: 48px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  padding: 0 100px 0 14px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #101828;\n  background: #fff;\n  outline: none;\n}\n\n/* .ca-evm__input:focus {\n  border-color: #c99400;\n  box-shadow: 0 0 0 3px rgba(201, 148, 0, 0.15);\n} */\n\n.ca-evm__getCode {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  padding: 6px 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #AC8A50;\n  cursor: pointer;\n}\n\n.ca-evm__getCode:hover {\n  color: #a67d00;\n}\n\n.ca-evm__submit {\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 999px;\n  background: #2b2b2b;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n\n.ca-evm__submit:hover:not(:disabled) {\n  background: #1a1a1a;\n}\n\n.ca-evm__submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.ca-evm__help {\n  display: block;\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 5px 0 20px;\n  letter-spacing: -0.45px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #AC8A50;\n  cursor: pointer;\n  text-align: center;\n}\n\n.ca-evm__help:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.ca-evm__footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding-top: 16px;\n  border-top: 1px solid #f1f5f9;\n  font-size: 14px;\n  font-weight: 500;\n  color: #939495;\n}\n\n.ca-evm__footer img {\n  width: 18px;\n  height: 18px;\n  display: block;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n\n@media (max-width: 991px) {\n\n  .ca-page__title {\n    margin: 0 0 15px;\n    font-size: 24px;\n  }\n\n  .ca-retention__sub {\n    margin: 0 0 12px;\n    font-size: 22px;\n  }\n\n  .ca-retention__text {\n    margin: 0 0 20px;\n    font-size: 15px;\n  }\n\n}\n\n\n\n@media (max-width: 767px) {\n\n  .ca-page__title {\n    margin: 0 0 15px;\n    font-size: 20px;\n  }\n\n  .ca-reason__heading {\n    font-size: 20px;\n  }\n\n  .ca-reason__option {\n    padding: 18px;\n    font-size: 14px;\n  }\n\n  .ca-retention__sub {\n    margin: 0 0 12px;\n    font-size: 17px;\n  }\n\n  .ca-assets__lead {\n    font-size: 20px;\n  }\n\n  body .button23 {\n    padding: 8px 24px;\n    margin-top: 10px;\n  }\n\n  .ca-assets__row {\n    font-size: 14px;\n    padding: 18px;\n  }\n\n  section.ca-assets {\n    margin: 30px auto;\n  }\n\n  .ca-modal-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .ca-modal {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .ca-evm__title {\n    font-size: 20px;\n  }\n\n  .ca-evm__desc {\n    font-size: 14px;\n  }\n\n  .ca-modal__title {\n    padding: 0 10px;\n    font-size: 20px;\n  }\n\n  .ca-evm__submit {\n    height: 42px;\n  }\n\n  .ca-evm-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .ca-evm {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .ca-retention__text {\n    margin: 0 0 20px;\n    font-size: 14px;\n  }\n\n  .ca-btn-primary {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .ca-retention {\n    margin: 20px auto 10px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
